module.exports = __webpack_public_path__ + "img/icon_menu_close.85c8286e.svg";